export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4609.39dc8958.jpg";